
import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Box, Button, IconButton } from '@material-ui/core';
import { Link } from "react-router-dom";
import { baseApiUrl } from '../dataProvider/sails';
import Typography from '@material-ui/core/Typography';
import HeaderSortable from '../common/header-sortable';
import { useTranslate } from 'react-admin';
import bin from '../assets/icons/primary-blue-bin.png';
import { useLocation } from "react-router-dom";
import { getDayMonthYear } from '../utils'
import moment from 'moment';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        fontWeight: 'inherit'
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        paddingTop: 8,
        paddingBottom: 8
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        fontFamily: 'UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.13px',
        color: '#ffffff',
        '&:hover': {
            color: '#ffffff'
        },
        '&:focus': {
            color: '#ffffff'
        },
    },
    textTableName: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
        textDecoration: 'none'
    },
    textTable: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textPublish: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: 'green',
    },
    textPublishNo: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: 'red',
    },
    textTableNoData: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        textAlign: 'center',
        padding: '30px'
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: ' 0.36px',
        color: '#6cb5b8',
        textAlign: 'center',
        padding: '8px',
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    }
}));

const headCells = [
    { id: 'icon', numeric: false, disablePadding: false, label: 'Icon' },
    { id: 'name', numeric: false, disablePadding: true, sorting: true, label: 'Name' },
    { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
    { id: '', numeric: false, disablePadding: false, label: '' }
];

function EnhancedTableHead(props) {
    const { classes, order, setOrder } = props;

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        className={classes.tableSortLabel}
                        key={'cell-' + headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                    >
                        {
                            headCell.label !== "" ?
                                headCell.sorting ?
                                    <HeaderSortable
                                        title={headCell.label}
                                        field={headCell.id}
                                        order={order}
                                        setOrder={setOrder}
                                    /> :
                                    headCell.label
                                : <Box />
                        }
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function UserTable({ data, getList, buttonHidden, total, handleDelete, error, setOpenDialog }) {
    const classes = useStyles();
    const translate = useTranslate();
    const location = useLocation();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState({ field: 'name', order: 'DESC' });
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPoper, setOpenPopper] = useState(false);
    const [openedit, setOpenEdit] = useState(false);

    const handleChangePage = (event, newPage) => {
        const pagination = { page: newPage + 1, perPage: rowsPerPage };
        getList(order, pagination);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);
        const pagination = { page: 1, perPage: event.target.value };
        getList(order, pagination);
    };

    const handleRequestSort = (nextSort) => {
        setPage(0);
        setOrder(nextSort);

        const pagination = { page: 1, perPage: rowsPerPage };
        getList(nextSort, pagination);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(!openedit);
    };

    return (

        // error > 0 ?
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table aria-label="sticky table">
                    <EnhancedTableHead classes={classes} order={order} setOrder={handleRequestSort} />
                    <TableBody>
                        {
                            data.map((item, index) => (
                                <TableRow key={'table-row-' + index} hover tabIndex={-1}>
                                    <TableCell key={index + '-2'} className={classes.tableCell}>
                                        {
                                            item.icon && <img style={{ borderRadius: '50%' }} src={baseApiUrl + '/media/' + JSON.parse(item.icon).fd} width={50} height={50} />
                                        }
                                    </TableCell>
                                    <TableCell key={index + '-0'} className={classes.tableCell}>{item.name}</TableCell>
                                    <TableCell key={index + '-1'} className={classes.tableCell}>{item.description}</TableCell>
                                    <TableCell key={index + '-3'} className={classes.tableCell} align='right'>
                                        {
                                            !buttonHidden &&
                                            <Box>
                                                <Button
                                                    variant="contained"
                                                    color='primary'
                                                    size='small'
                                                    onClick={() => setOpenDialog(item)}
                                                >
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.user.edituser`)} </Typography>
                                                </Button>
                                                <IconButton

                                                    style={{ marginLeft: '1em', padding: '10px' }}
                                                    className={classes.borderDelete}
                                                    size='small'
                                                    onClick={() => handleDelete(index)}
                                                >
                                                    {/* <Delete color='primary' /> */}
                                                    <img src={bin} style={{ width: "15px" }} />
                                                </IconButton>
                                            </Box>
                                        }


                                    </TableCell>
                                </TableRow>
                            ))
                        }

                    </TableBody>
                </Table>
            </TableContainer>


            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
        //  :<Typography className={classes.textTableNoData}>{translate(`pos.user.error.datanotfound`)} </Typography>
    );
}

export default UserTable;
